export const QSI_KEY = {
  USER_ID: 'user_id',
  USER_COMPANY_ID: 'company_id',
  USER_ROLE: 'role',
  USER_CATEGORY: 'category',
};

export const QSI_BTN_IDS = {
  CLI_PERM_GROUP: {
    CREATE: {
      CLOSE: 'create-client-perm-group-close',
      SAVE: 'create-client-perm-group-save',
      YES_CANCEL: 'create-client-perm-group-dontsave',
    },
    EDIT: {
      CLOSE: 'edit-client-perm-group-close',
      SAVE: 'edit-client-perm-group-save',
      YES_CANCEL: 'edit-client-perm-group-dontsave',
    },
  },
  PROJ_PERM_GROUP: {
    CREATE: {
      CLOSE: 'create-project-perm-group-close',
      SAVE: 'create-project-perm-group-save',
      YES_CANCEL: 'create-project-perm-group-dontsave',
    },
    EDIT: {
      CLOSE: 'edit-project-perm-group-close',
      SAVE: 'edit-project-perm-group-save',
      YES_CANCEL: 'edit-project-perm-group-dontsave',
    },
  },
  PROJECT_VIEW: {
    EXPORT: 'export-project-view-report',
  },
};
